import { Action } from '../../shared/interfaces/shared';
import { ImportLines, ImportLinesRequest } from '../interfaces/import-lines';
import { ImportType } from '../interfaces/import-type';
import { NewImportType } from '../interfaces/dto/new-import-type';
import { UploadFile } from '../interfaces/upload-file';

export const IMPORTING = 'IMPORTING';
export const importingFile = (bool: boolean): Action<boolean> => ({
    type: IMPORTING,
    payload: bool,
});

export const GET_IMPORT_TYPES_REQ = 'GET_IMPORT_TYPES_REQ';
export const getImportTypesReq = (): Action<null> => ({
    type: GET_IMPORT_TYPES_REQ,
    payload: null,
});

export const GET_IMPORT_TYPES_OK = 'GET_IMPORT_TYPES_OK';
export const getImportTypesOk = (users: ImportType[]): Action<ImportType[]> => ({
    type: GET_IMPORT_TYPES_OK,
    payload: users,
});

export const GET_IMPORT_TYPES_FAIL = 'GET_IMPORT_TYPES_FAIL';
export const getImportTypesFail = (error: Error) => ({
    type: GET_IMPORT_TYPES_FAIL,
    payload: error,
});

export const SET_ADD_IMPORT_TYPE_MODAL = 'SET_ADD_IMPORT_TYPE_MODAL';
export const setAddImportTypeModal = (flag: boolean) => ({
    type: SET_ADD_IMPORT_TYPE_MODAL,
    payload: flag,
});

export const CREATE_IMPORT_TYPE_REQ = 'CREATE_IMPORT_TYPE_REQ';
export const createImportTypeReq = (importType: NewImportType) => ({
    type: CREATE_IMPORT_TYPE_REQ,
    payload: importType,
});

export const CREATE_IMPORT_TYPE_OK = 'CREATE_IMPORT_TYPE_OK';
export const createImportTypeOk = (importType: ImportType) => ({
    type: CREATE_IMPORT_TYPE_OK,
    payload: importType,
});

export const CREATE_IMPORT_TYPE_FAIL = 'CREATE_IMPORT_TYPE_FAIL';
export const createImportTypeFail = (error: Error) => ({
    type: CREATE_IMPORT_TYPE_FAIL,
    payload: error,
});

export const REFRESH_TOTALS_REQ = 'REFRESH_TOTALS_REQ';
export const refreshTotalsReq = (): Action<null> => ({
    type: REFRESH_TOTALS_REQ,
    payload: null,
});

// Pas de REFRESH_TOTALS_OK : la réponse est la liste complète à jour, GET_IMPORT_TYPES_OK fait déjà le travail
export const REFRESH_TOTALS_FAIL = 'REFRESH_TOTALS_FAIL';
export const refreshTotalsFail = (error: Error) => ({
    type: REFRESH_TOTALS_FAIL,
    payload: error,
});

export const CLEAR_IMPORT_TYPE_REQ = 'CLEAR_IMPORT_TYPE_REQ';
export const clearImportTypeReq = (id: number) => ({
    type: CLEAR_IMPORT_TYPE_REQ,
    payload: id,
});

export const CLEAR_IMPORT_TYPE_OK = 'CLEAR_IMPORT_TYPE_OK';
export const clearImportTypeOk = (importType: ImportType) => ({
    type: CLEAR_IMPORT_TYPE_OK,
    payload: importType,
});

export const CLEAR_IMPORT_TYPE_FAIL = 'CLEAR_IMPORT_TYPE_FAIL';
export const clearImportTypeFail = (error: Error) => ({
    type: CLEAR_IMPORT_TYPE_FAIL,
    payload: error,
});

export const UPLOAD_GEOJSON_FILE_REQ = 'UPLOAD_GEOJSON_FILE_REQ';
export const uploadGeoJsonFileReq = (uploadFile: UploadFile) => ({
    type: UPLOAD_GEOJSON_FILE_REQ,
    payload: uploadFile,
});

export const UPLOAD_GEOJSON_FILE_OK = 'UPLOAD_GEOJSON_FILE_OK';
export const uploadGeoJsonFileOk = (importType: ImportType) => ({
    type: UPLOAD_GEOJSON_FILE_OK,
    payload: importType,
});

export const UPLOAD_GEOJSON_FILE_FAIL = 'UPLOAD_GEOJSON_FILE_FAIL';
export const uploadGeoJsonFileFail = (error: Error) => ({
    type: UPLOAD_GEOJSON_FILE_FAIL,
    payload: error,
});

export const GET_IMPORT_LINES_REQ = 'GET_IMPORT_LINES_REQ';
export const getImportLinesReq = (request: ImportLinesRequest): Action<ImportLinesRequest> => ({
    type: GET_IMPORT_LINES_REQ,
    payload: request,
});

export const GET_IMPORT_LINES_OK = 'GET_IMPORT_LINES_OK';
export const getImportLinesOk = (importLines: ImportLines): Action<ImportLines> => ({
    type: GET_IMPORT_LINES_OK,
    payload: importLines,
});

export const GET_IMPORT_LINES_FAIL = 'GET_IMPORT_LINES_FAIL';
export const getImportLinesFail = (error: Error) => ({
    type: GET_IMPORT_LINES_FAIL,
    payload: error,
});

// Efface les lignes de la carte sans rien demander à l'api
export const CLEAR_IMPORT_LINES = 'CLEAR_IMPORT_LINES';
export const clearImportLines = (): Action<null> => ({
    type: CLEAR_IMPORT_LINES,
    payload: null,
});